module.exports = __webpack_public_path__ + "kaitak-ogp.f4d8f8175cfb8152fc82.jpg";